import { type FC } from "react";
import {
  DetailCard,
  DetailCardRow,
  DetailCardsGrid,
} from "../../../components/detail-cards";
import {
  formatMinorUnits,
  PAYABLE_ENTITY_TAB_LABELS,
  type PriceCatalogueProfile,
} from "../types";

interface FixedMonthlyPlanProfilesCardsProps {
  profiles: PriceCatalogueProfile[];
}

const FixedMonthlyPlanProfilesCards: FC<FixedMonthlyPlanProfilesCardsProps> = ({
  profiles,
}) => {
  if (!profiles.length) return null;

  return (
    <DetailCardsGrid $columns={3}>
      {profiles.map((profile) => {
        const plan = profile.fixedMonthlyPlans?.[0] ?? null;
        return (
          <DetailCard key={profile.id} title={profile.label || profile.key}>
            <DetailCardRow label="Key" value={profile.key} />
            <DetailCardRow label="Option" value={profile.subscriptionOption} />
            <DetailCardRow
              label="Currency"
              value={String(profile.billingCurrency || "").toUpperCase()}
            />
            <DetailCardRow label="Interval" value={profile.interval || "—"} />
            <DetailCardRow
              label="Payment type"
              value={
                plan
                  ? PAYABLE_ENTITY_TAB_LABELS[plan.payableEntityType] ||
                    plan.payableEntityType
                  : "—"
              }
            />
            <DetailCardRow
              label="Monthly fee"
              value={formatMinorUnits(
                plan?.monthlyFeeMinorUnits,
                profile.billingCurrency
              )}
            />
            <DetailCardRow
              label="Transaction limit"
              value={
                plan?.transactionLimit != null
                  ? plan.transactionLimit.toLocaleString("en-GB")
                  : "—"
              }
            />
          </DetailCard>
        );
      })}
    </DetailCardsGrid>
  );
};

export default FixedMonthlyPlanProfilesCards;
